import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const forescoutEyeInspect = defineConnector({
  identifier: "forescoutEyeInspect",
  name: "Forescout eyeInspect",
  tagLine: "Operational technology security",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://eyeinspect.example.com/api/v1"),
  auth: basicAuth({
    username: { from: "secret", field: "username" },
    password: { from: "secret", field: "password" },
  }),
  steps: [
    {
      title: "Set up Forescout eyeInspect",
      items: [
        {
          kind: "markdown",
          content:
            "Ask your eyeInspect administrator for an account with read access to the Command Center API. Enter the Command Center’s HTTPS API URL, username, and password below. The connection test reads at most one passive sensor. See the [sensor API reference](https://docs.forescout.com/eyeinspect/eyeinspect-rn-api-user-guide/eyeinspect-api-guide/sensors.htm).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          placeholder: "https://eyeinspect.example.com/api/v1",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Enter the hostname or IP address of your eyeInspect Command Center using HTTPS on port 443, followed by /api/v1.",
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          target: {
            kind: "secrets",
            field: "username",
          },
          helperText: "Username for the eyeInspect Command Center API.",
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: {
            kind: "secrets",
            field: "password",
          },
          helperText:
            "Password for the Forescout user profile used for HTTP Basic Authentication.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://eyeinspect.example.com/api/v1")
          .trim()
          .replace(/\/+$/, "") + "/sensors?limit=1",
      method: "GET",
    }),
  },
});
